<template>
  <div :class="componentStyle.header + '-header'">
    <!-- Modal -->
    <div v-if="hasOptionsTv" class="modal fade" id="modal-contact" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel"> {{ $t('labels.contact') }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form class="needs-validation" novalidate>
          <div class="modal-body">

            <div class="form-group">
              <label for="email">{{ $t('modal.from') }} <b class="oblig"> *</b></label>
              <input
                v-model="email"
                v-bind:class="{'form-control':true, 'is-invalid' : !validEmail(email) && emailBlured}"
                v-on:blur="emailBlured = true">
              <div class="invalid-feedback">{{ $t('modal.error_mail') }} </div>
            </div>
            <div class="form-group">
              <label for="messageMail">{{ $t('modal.message') }} <b class="oblig"> *</b></label>
              <textarea v-model="messageMail"
                        class="form-control"
                        id="messageMail"
                        rows="3"
                        v-on:blur="messageMailBlured = true"
                        v-bind:class="{'form-control':true, 'is-invalid' : !validMessageMail(messageMail) && messageMailBlured}"></textarea>
              <div class="invalid-feedback">{{ $t('modal.error_message') }}</div>

            </div>

          </div>
          <div class="modal-footer">
            <button type="submit"  :disabled="isSending" v-on:click.stop.prevent="submit" class="btn btn-primary">{{ $t('modal.send') }}</button>
          </div>
          </form>
        </div>
      </div>
    </div>

    <div class="row main-content-page">
      <div
        class="side-nav-wrapper col-lg-2 d-none"
        :class="[
          {
            'd-lg-block': isSideNav,
            'col-lg-2': isHeaderInfo,
            'main-background side-nav-wrapper-fixed': isHeaderInfo,
          },
        ]"
      >
        <side-nav />
      </div>
      <div
        class="main-page-container col-md-12"
        :class="[
          {
            'col-lg-12': isFullWidth,
            'col-lg-10': isSideNav,
            'main-background main-fixed': isHeaderInfo,
            'has-options-tv':hasOptionsTv
          },
        ]"
      >
        <header-menu v-if="!isHeaderInfo"></header-menu>
        <header-content-info v-if="isHeaderInfo"></header-content-info>
        <div :class="['large-header title-wrapper']">
          <div class="container">
            <h1 class="title">
              <i class="fo-icon-home"></i>
              {{ $t('menu.home') }}
            </h1>
          </div>
        </div>
        <div

          :class="[
           { 'container' : !hasOptionsTv},
            {
              ['container-' + componentStyle.header]: isHeaderInfo,
              ['container-default-' + componentStyle.header]: isHeaderInfo && currentTheme === 0,
            },
            {'hidden-scroll':hasOptionsFormation}
          ]"
        >
          <main-content></main-content>
          <video-cards v-if="getVideoCards"></video-cards>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SideNav from './SideNav';
import HeaderMenu from './HeaderMenu';
import HeaderContentInfo from './HeaderContentInfo';
import MainContent from './MainContent';
import VideoCards from './VideoCards';
import PageFooter from './PageFooter';
import DefaultHeaderInfo from './DefaultHeaderInfo';
import { service } from '../service';

export default {
  name: 'HomePage',
  metaInfo: {
    title: process.env.META_TITLA,
  },
  components: {
    SideNav,
    HeaderMenu,
    HeaderContentInfo,
    MainContent,
    VideoCards,
    PageFooter,
    DefaultHeaderInfo,
  },
  computed: {
    ...mapGetters({
      isFullWidth: 'layout/isFullWidth',
      isSideNav: 'layout/isSideNav',
      componentStyle: 'layout/getComponentStyle',
      currentSkin: 'layout/getCurrentSkin',
      videos: 'videos/getAllVideos',
      isHeaderInfo: 'layout/isHeaderInfo',
      currentTheme: 'videos/getCurrentTheme',
      hasOptionsTv: 'layout/hasOptionsTv',
      playerUrl: 'videos/getPlayerUrl',
      hasOptionsFormation: 'layout/hasOptionsFormation'

    }),
    getVideoCards(){
      return this.hasOptionsTv && !this.isCir ? this.mobileVersion :  true
    },
    isCir(){
      return process.env.IS_CIR;
    },
  },
  methods: {
    ...mapActions('videos', ['setCurrentVideo','getCryptedUrl','setCurrentCategory','paginateVideos','fetchRelated']),

    validate : function(){
      this.emailBlured = true;
      this.messageMailBlured = true;
      if( this.validEmail(this.email) && this.validMessageMail(this.messageMail)){
        this.valid = true;
      }
    },
    validEmail : function(email) {
      var re = /(.+)@(.+){2,}\.(.+){2,}/;
      return re.test(email.toLowerCase());
    },
    validMessageMail : function(message) {
      var pattern =/\S+/;
      return pattern.test(message)
    },
    submit(){
      let self= this;
      this.validate();

      self.isSending=true

      if(this.valid){

        let param={
          from:self.email,
          message:self.messageMail,
          user:self.$cookies.get('tokenUserFo')
        }


        service.contactUs(param).then(function() {
          self.$toast.open({
            message: self.$t('send_mail'),
            type: 'success',
          });

            self.isSending=false

          }

        ).catch(function() {
          self.$toast.open({
            message: self.$t('error_send_mail'),
            type: 'error',
          });

          self.isSending=false

        })




        //THIS IS WHERE YOU SUBMIT DATA TO SERVER
        this.submitted = true;
      }
    } //end submit

  },
  data() {
    return {
      email : "",
      messageMail : "",
      emailBlured : false,
      messageMailBlured : false,
      valid : false,
      isSending:false,
      mobileVersion:false
    };
  },
  async mounted() {
    this.mobileVersion=  window.innerWidth <= 991;
    window.addEventListener('resize', () => {
      this.mobileVersion=  window.innerWidth <= 991;
    });
    if((this.hasOptionsTv && !this.isCir) ){//| (this.hasOptionsFormation ||this.hasOptions)
      this.paginateVideos();
    }else if(this.hasCarousel || this.isCir){
      this.fetchRelated(process.env.ID_CHANNEL);
    }
  },
};
</script>

<style scoped lang="scss">
.main-page-container {
  min-height: 100vh;
  background-color: #fafafa;
  padding: 0 !important;
  &.has-options-tv{
    @media screen and (max-width:992px) {
      padding: 0 !important;
      overflow-x: hidden;
    }
  }
  &.main-background {
    background-color: #ffffff;
    padding: 0;
  }
  &.main-fixed {
    position: absolute;
    right: 0;
  }
}

.side-nav-wrapper {
  background-color: #ebeef1;
  &.main-background {
    background-color: #ffffff;
    border-right: 1px solid #ebeef1;
  }
  &.side-nav-wrapper-fixed {
    position: fixed;
    left: 0;
  }
}
.container{
 // padding: 0 5px!important;
}
@media (max-width: 575px) {
  .container {
   // padding-right: 0;
   // padding-left: 0;
  }
}

@media (min-width: 576px) {
  .container {
    max-width: 100% !important;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 100% !important;
    &.hidden-scroll{
      padding: 0 5px!important;
      overflow: hidden;
    }
  }
}
@media (max-width: 767px) {
  .container {
    &.hidden-scroll{
      padding: 0 5px!important;
      overflow: hidden;
    }
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  /deep/ .col-lg-3 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .container-default-info {
    position: absolute;
    top: 15em;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1180px;
    overflow: hidden;
    &.container-default-info {
      position: absolute;
      top: 15em;
    }
  }
}

@media (min-width: 1600px) {
  .container {
    &:not(.container-info) {
      max-width: 1500px !important;
    }
    &.container-info {
      max-width: 1548px;
    }
    &.container-default-info {
      position: absolute;
      top: 15em;
    }
  }
}
.container-info.main-position {
  margin-top: 145px;
}
  .oblig{
    color: red;
  }
  .main-content-page{
    margin: 0!important;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue